//
// http://gitlab.qtang.net/luolj/hbgj-api/blob/master/desc.md
//
import md5 from 'blueimp-md5'
import device from '../../utils/device'
import env from '../../utils/env'
import localStorage from '@/utils/localStorage'
const queryString = require('query-string')

const DEFAULT_PARAMS = {
  client: 'vuetrainweb',
  source: 'vuetrainweb',
  platform: 'web',
  cver: '7.0',
  dver: '0',
  iver: '5.32',
  format: 'json'
}

// 根据渠道参数及推广参数，修改默认系统参数
/* global HLCX_PARTNER_SOURCE */
if (window[HLCX_PARTNER_SOURCE]) {
  DEFAULT_PARAMS.source = window[HLCX_PARTNER_SOURCE]
}

/* global HLCX_ENTRY_SOURCE */
if (window[HLCX_ENTRY_SOURCE]) {
  DEFAULT_PARAMS.analyseSourceEntry = window[HLCX_ENTRY_SOURCE]
}

const p = [
  DEFAULT_PARAMS.source,
  env.os,
  DEFAULT_PARAMS.client,
  DEFAULT_PARAMS.cver,
  DEFAULT_PARAMS.platform
].join(',')

const defaultParams = device.get().then(d => {
  let parsed = queryString.parse(location.search);
  let ptid = localStorage.get('ptid') || parsed.ptid || '';

  return Object.assign({}, {
    ...DEFAULT_PARAMS,
    uid: d.uid,
    imei: d.imei,
    uuid: d.uuid,
    p,
    appinfo: d.p || p,
  }, 
  ptid ? {
    source: ptid
  } : {}
  )
})

function getCommonParams() {
  return defaultParams.then(params => {
    return Object.assign({
      ...params,
      systemtime: new Date().getTime()
    }, env.quickBrandSource ? {
      ai_from: env.quickBrandSource
    } : {})
  })
}

function generateSid(keys, obj, toUpper = true) {
  let s = keys.map(k => (obj[k])).join('')
  let e = md5(s + '/2g!q^l&$5')
  let sid = [9, 13, 10, 20, 11, 26, 17, 12].map(i => (e[i])).join('')
  return toUpper ? sid.toUpperCase() : sid
}

export default {
  getCommonParams,
  generateSid
}



// WEBPACK FOOTER //
// ./src/request/transformers/hbgj-api.js